<p-toast></p-toast>
<div *ngIf="redimir" class="form-container">
    <form id="redimiratender" [formGroup]="redeemForm" (ngSubmit)="onSubmit()">

        <h2 style="text-align: center;">{{redimir.supervisor.nom_supervisor}}</h2>

        <div class="form-group">
            <label for="cantidad">Cantidad:</label>
            <p-inputNumber formControlName="cantidad" inputId="cantidad" [readonly]="true"
                placeholder="Ingrese la cantidad" styleClass="inputnumber" />
            <div *ngIf="redeemForm.get('cantidad')?.touched && redeemForm.get('cantidad')?.errors"
                class="error-message">
                <span *ngIf="redeemForm.get('cantidad')?.errors?.['required']">
                    La cantidad es requerida
                </span>
                <span *ngIf="redeemForm.get('cantidad')?.errors?.['min']">
                    La cantidad debe ser mayor a 0
                </span>
            </div>
        </div>

        <div class="form-group">
            <label for="fechaFinal">Fecha Final*:</label>
            <input type="date" id="fechaFinal" formControlName="fechaFinal" class="form-control">
            <div *ngIf="redeemForm.get('fechaFinal')?.touched && redeemForm.get('fechaFinal')?.errors?.['required']"
                class="error-message">
                La Fecha es requerida
            </div>
        </div>

        <div class="form-group">
            <label for="observacion">Observación*:</label>
            <textarea id="observacion" formControlName="observacion" class="form-control" maxlength="255" rows="4">
      </textarea>
            <div *ngIf="redeemForm.get('observacion')?.touched && redeemForm.get('observacion')?.errors?.['required']"
                class="error-message">
                La Observación es requerida
            </div>
        </div>

        <div class="form-group file-upload">
            <label class="file-label">
                <span class="file-text">{{ archivoSeleccionado ? archivoSeleccionado.name : 'Seleccionar archivo'
                    }}</span>
                <input type="file" (change)="onFileSelected($event)" accept=".pdf,.doc,.docx,.xls,.xlsx"
                    class="file-input">
                <span class="file-button">Examinar</span>
            </label>
        </div>

    </form>
    <div *ngIf="redimir" class="wrapper">
        <table style="width: 100%;">
            <thead>
                <tr>
                    <td colspan="3">Casos Clinicos</td>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let casoclinico of redimir.casosclinicos">
                    <td>{{casoclinico.serie}}</td>
                    <td>{{casoclinico.nomHospital}}</td>
                    <td>{{casoclinico.e_puntos}}</td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <td colspan="2" class="text-right">Total Puntos:</td>
                    <td>{{cantidad}}</td>
                </tr>
            </tfoot>
        </table>
    </div>
    <div class="button-group">
        <button type="button" (click)="onExit()" class="salir-button">
            Salir
        </button>
        <!--
   
    <button type="button" (click)="onCancel()" class="cancel-button">
      Cancelar
    </button>

    <button type="button" (click)="onReject()" class="reject-button">
      Rechazar
    </button>
-->
        <button type="submit" form="redimiratender"
            [disabled]="!redeemForm.valid || !archivoSeleccionado || redimir.casosclinicos.length === 0"
            class="submit-button">
            Aceptar
        </button>
    </div>
</div>

<!-- Modal de confirmación -->
<div class="modal" *ngIf="showModal">
    <div class="modal-content">
        <h3>{{ modalTitle }}</h3>
        <p>{{ modalMessage }}</p>
        <div class="modal-buttons">
            <button type="button" (click)="confirmarAccion()" class="btn-confirm">Confirmar</button>
            <button type="button" (click)="cancelarAccion()" class="btn-cancel">Cancelar</button>
        </div>
    </div>
</div>